export const ROOT = `/`;

export const BACKOFFICE_LAYOUT = `/backoffice`;

export const DASHBOARD = `${BACKOFFICE_LAYOUT}/dashboard`;

export const ORDERS = `${BACKOFFICE_LAYOUT}/orders`;

export const MY_HUBS = `${BACKOFFICE_LAYOUT}/my-hubs`;

export const MY_HUBS_MEMBERSHIP = `${BACKOFFICE_LAYOUT}/my-hubs/membership`;
export const MY_HUBS_SUBCRRIPTION = `${BACKOFFICE_LAYOUT}/my-hubs/subcription`;
export const MY_HUBS_SUBCRRIPTION_BUNDLE = `${BACKOFFICE_LAYOUT}/my-hubs/subcription-bundle`;

export const MY_HUBS_SUPER_SALES = `${BACKOFFICE_LAYOUT}/my-hubs/super-sales`;

export const MY_HUBS_ACCESS_PACKS = `${BACKOFFICE_LAYOUT}/my-hubs/access-packs`;

export const MY_HUBS_VIP = `${BACKOFFICE_LAYOUT}/my-hubs/vip`;

export const MY_TEAM = `${BACKOFFICE_LAYOUT}/my-team`;

export const EARNINGS = `${BACKOFFICE_LAYOUT}/earnings`;

export const RANKING = `${BACKOFFICE_LAYOUT}/ranking`;

export const MONTLY = `${BACKOFFICE_LAYOUT}/montly`;

export const RESOURCES = `${BACKOFFICE_LAYOUT}/resources`;

export const DUBAI_PROMOTION = `${BACKOFFICE_LAYOUT}/dubai-promotion`;

export const SUPER_SALES = `${BACKOFFICE_LAYOUT}/super-sales`;

export const ACCESS_PACKS = `${BACKOFFICE_LAYOUT}/access-packs`;

export const TRAVEL_PACKAGES = `${BACKOFFICE_LAYOUT}/travel-packages`;

export const CRUISES_PROMOTION = `${BACKOFFICE_LAYOUT}/event-promotion-cruises`;

export const EVENT_PROMOTION = `${BACKOFFICE_LAYOUT}/event-promotion`;

export const SETTINGS_LAYOUT = `${BACKOFFICE_LAYOUT}/settings`;

export const SETTINGS_ACCOUNT = `${SETTINGS_LAYOUT}/account`;

export const SETTINGS_SECURITY = `${SETTINGS_LAYOUT}/security`;

export const SETTINGS_PAYMENTS = `${SETTINGS_LAYOUT}/payments`;

export const SETTINGS_NOTIFICATIONS = `${SETTINGS_LAYOUT}/notifications`;

export const SETTINGS_TEAM_SETTINGS = `${SETTINGS_LAYOUT}/team-settings`;

export const SETTINGS_VIRTUAL_OFFICE = `${SETTINGS_LAYOUT}/virtual-office`;

export const HELPDESK = `${BACKOFFICE_LAYOUT}/helpdesk`;

export const HELPDESK_SUPPORT = `${BACKOFFICE_LAYOUT}/helpdesk-support`;

export const HELPDESK_SUBCATEGORY = `${BACKOFFICE_LAYOUT}/subcategory`;

export const HELPDESK_QUESTION = `${BACKOFFICE_LAYOUT}/question`;

export const ACCOUNTING = `${BACKOFFICE_LAYOUT}/accounting`;

export const CASHBACK_BONUS = `${BACKOFFICE_LAYOUT}/cashback-bonus`;

export const POOL_BONUS = `${BACKOFFICE_LAYOUT}/pool-bonus`;

export const TOP_PERFORMER_BONUS = `${BACKOFFICE_LAYOUT}/top-performer-bonus`;

export const HODL_BONUS = `${BACKOFFICE_LAYOUT}/hodl-bonus`;

export const TERMS_OF_USE = `${BACKOFFICE_LAYOUT}/terms-of-use`;

export const PRIVACY_POLICY = `${BACKOFFICE_LAYOUT}/privacy-policy`;

export const COOKIE_POLICY = `${BACKOFFICE_LAYOUT}/cookie-policy`;

// export const GAMING = `${BACKOFFICE_LAYOUT}/gaming`;

export const PAYMENT = `${BACKOFFICE_LAYOUT}/payment`;

export const FLIPME_CARDS = `${BACKOFFICE_LAYOUT}/flipme-cards`;

export const TRADING = `${BACKOFFICE_LAYOUT}/trading`;

export const BIG_WHALE = `${BACKOFFICE_LAYOUT}/big-whale`;

export const DISCOUNT_CODE = `${BACKOFFICE_LAYOUT}/discount-code`;

export const MARKETPLACE = `${BACKOFFICE_LAYOUT}/marketplace`;

export const FIRST_BUY_VIRTUAL_OFFICE = `${BACKOFFICE_LAYOUT}/first-buy-gift-bonus`;

// export const SUPPORT_TICKETS = `${BACKOFFICE_LAYOUT}/support-tickets`;

// AUTH

export const LOGIN = `/login`;

export const FIRST_LOGIN = `/first-login`;

export const PROFILE_DETAILS = `/profile-details`;

export const SECURITY_CODE = `/security-code`;

export const PASSWORD = `/password`;

export const TERMS_AND_CONDITIONS = `/terms-and-conditions`;

export const REFERRAL = `/referral`;

export const EMAIL_ADDRESS = `/email-address`;

//KYC

export const KYC_LAYOUT = `/kyc`;

export const KYC_START = `${KYC_LAYOUT}/start`;

export const KYC_AGREEMENT = `${KYC_LAYOUT}/agreement`;

export const KYC_BIRTH_DETAILS = `${KYC_LAYOUT}/birth-details`;

export const KYC_DOCUMENT_DETAILS = `${KYC_LAYOUT}/document-details`;

export const KYC_DOCUMENT_PHOTOS = `${KYC_LAYOUT}/document-photos`;

export const KYC_SELFIE_TIME = `${KYC_LAYOUT}/selfie-time`;

export const KYC_CONGRATULATIONS = `${KYC_LAYOUT}/congratulations`;

// INTRO

export const INTRO_LAYOUT = `/intro`;

export const INTRO_WELCOME = `${INTRO_LAYOUT}/welcome`;

// TERMS MIGRATED
export const TERMS_MIGRATED_LAYOUT = `/terms-migrated`;

export const TERMS_AND_CONDITIONS_MIGRATED_CHECK = `${TERMS_MIGRATED_LAYOUT}/terms-migrated-check`;
